{
    "translation": {
        "welcome": "Welcome",
        "home": "Home",
        "find_pro": "Find a Pro",
        "admin": "Admin",
        "my_space": "My Space",
        "login": "Login",
        "logout": "Logout",
        "search_placeholder": "Hairdresser, Barber, Manicure...",
        "hero_title": "Book your beauty appointment",
        "hero_subtitle": "Find the best professionals near you.",
        "search_btn": "Search",
        "popular_services": "Popular Services",
        "footer_rights": "All rights reserved.",
        "legal_mentions": "Legal Mentions",
        "cgp": "General Terms of Service",
        "feature_search_title": "Search",
        "feature_search_desc": "Find the best salons and experts near you",
        "feature_book_title": "Book",
        "feature_book_desc": "Choose your ideal slot in seconds",
        "feature_enjoy_title": "Enjoy",
        "feature_enjoy_desc": "Live a unique and relaxing beauty experience",
        "featured_pros_title": "Featured Professionals",
        "reviews_count": "reviews",
        "client_space": "CLIENT AREA",
        "my_bookings": "My Bookings",
        "explore_map": "Explore Map",
        "edit_photo": "Edit Photo",
        "photo_updated": "Profile photo updated!",
        "error_upload": "Error uploading photo.",
        "hero_welcome": "Welcome to OpenGlow",
        "hero_slogan": "Excellence at your fingertips.",
        "hero_desc": "Book your beauty and wellness treatments in a few clicks. Simple, fast and elegant.",
        "i_am_pro": "I am a professional",
        "featured_pros_desc": "Discover our recommended experts for excellent services",
        "verified_reviews": "verified reviews",
        "book_verb": "Book",
        "default_location": "Paris, France",
        "login_title": "Login",
        "email_label": "Email",
        "password_label": "Password",
        "login_btn": "Login",
        "no_account": "No account yet?",
        "register_link": "Sign up",
        "register_title": "Register",
        "client_role": "Client",
        "pro_role": "Professional",
        "firstname_label": "First Name",
        "lastname_label": "Last Name",
        "birthdate_label": "Date of Birth",
        "profession_label": "Profession",
        "company_label": "Company Name",
        "siret_label": "SIRET",
        "register_btn": "Sign up",
        "already_account": "Already have an account?",
        "login_link": "Login",
        "login_error": "Login error",
        "register_error": "Registration error",
        "generic_error": "An error occurred.",
        "search_title": "Find your beauty professional",
        "search_placeholder": "Search for a salon, address, specialty...",
        "search_action": "Search",
        "filters_all": "All",
        "filter_sort": "Filters",
        "filter_distance_nearest": "Distance: nearest",
        "filter_rating_highest": "Rating: highest",
        "filter_reviews_most": "Reviews: most",
        "filter_name_az": "Name: A-Z",
        "filter_min_rating": "Minimum rating",
        "filter_max_distance": "Max distance",
        "show_filters": "Show filters",
        "hide_filters": "Hide filters",
        "map_style": "Style",
        "map_enable_location_filter": "Enable location to filter by distance",
        "results_label": "result(s)",
        "available_pros": "Available professionals",
        "view_profile": "View profile",
        "no_results_title": "No professionals found",
        "no_results_desc": "Try modifying your search criteria",
        "loading": "Loading...",
        "profession_hairdresser": "Hairdresser",
        "profession_esthetician": "Esthetician",
        "profession_barber": "Barber",
        "profession_manicure": "Manicure",
        "profession_masseur": "Masseur",
        "bookings_title_client": "My Bookings",
        "bookings_title_pro": "Booking Management",
        "bookings_subtitle_client": "View your appointments",
        "bookings_subtitle_pro": "Manage your client appointments",
        "status_pending": "Pending",
        "status_confirmed": "Confirmed",
        "status_revenue": "Completed services",
        "filter_all": "All",
        "filter_pending": "Pending",
        "filter_confirmed": "Confirmed",
        "filter_completed": "Completed",
        "filter_cancelled": "Cancelled",
        "badge_pending": "⏳ Pending",
        "badge_confirmed": "✓ Confirmed",
        "badge_completed": "✓ Completed",
        "badge_cancelled": "✕ Cancelled",
        "label_service": "Service",
        "label_date": "Date",
        "label_time": "Time",
        "label_duration": "Duration",
        "label_price": "Price",
        "promo_applied": "Promo applied",
        "label_notes": "Notes",
        "action_confirm": "Confirm",
        "action_complete": "Complete",
        "action_cancel": "Cancel",
        "action_delete": "Delete",
        "confirm_delete_booking": "Delete this booking?",
        "no_bookings_title": "No bookings",
        "no_bookings_desc": "Nothing to display at the moment.",
        "return_btn": "Back",
        "pro_not_found": "Professional not found",
        "default_pro_desc": "Welcome to my booking page.",
        "view_reviews": "View reviews",
        "services_title": "Services",
        "no_services": "No services available.",
        "gallery_title": "Gallery",
        "booking_title": "Booking",
        "label_select_service": "1. Service",
        "placeholder_select_service": "Select a service...",
        "label_select_date": "2. Date",
        "label_select_slot": "3. Time Slot",
        "loading_slots": "Loading slots...",
        "no_slots_available": "No slots available on this day.",
        "total_label": "Total",
        "confirm_booking_btn": "Confirm Booking",
        "alert_login_required": "Please login to book",
        "alert_select_service": "Please select a service",
        "alert_booking_success": "Booking confirmed! 🎉",
        "alert_booking_error": "Error during booking",
        "announcements_title": "Announcements & Promotions",
        "nav_announcements": "Announcements",
        "profile_name_required": "First name and last name are required.",
        "profile_update_error": "Error updating profile.",
        "profile_update_success": "Profile updated successfully.",
        "network_error_retry": "Network error. Please try again.",
        "delete_account_title": "Delete my account",
        "delete_account_message": "This action is irreversible. All your data (bookings, reviews, photos) will be permanently deleted in accordance with your right to erasure (GDPR art. 17).",
        "delete_account_confirm": "Delete permanently",
        "delete_account_error": "Error deleting account.",
        "profile_edit_close": "Close editing",
        "profile_edit_open": "Edit my profile",
        "phone_label": "Phone",
        "profile_phone_placeholder": "Ex: +33 6 12 34 56 78",
        "saving": "Saving...",
        "save_changes": "Save changes",
        "delete_my_account": "Delete my account",
        "not_available": "N/A",
        "pro_tab_overview": "Overview",
        "pro_tab_bookings": "Bookings",
        "pro_tab_planning": "Planning",
        "pro_tab_services": "Services",
        "pro_tab_reviews": "Client Reviews",
        "pro_tab_announcements": "Announcements",
        "pro_tab_profile": "My Profile",
        "pro_photos_added": "Photos added!",
        "pro_visuals_title": "Photos & Visuals",
        "pro_profile_photo": "Profile photo",
        "pro_profile_photo_desc": "Appears on your public page so clients can recognize you easily.",
        "pro_gallery_title": "Image Gallery (Salon & Work)",
        "pro_add_photos": "Add photos",
        "pro_no_photos": "No photos yet.",
        "pro_set_cover": "Set as cover",
        "pro_cover_badge": "Cover",
        "pro_cover_updated": "Cover photo updated!",
        "pro_client_view": "Client view",
        "pro_client_view_desc": "See your page as a client",
        "open_in_maps": "Open in Maps",
        "pro_no_photos_desc": "Add photos of your space or your work to attract more clients.",
        "pro_price_display_mode": "Price Display",
        "pro_price_display_hint": "Choose how your prices appear on your public page.",
        "pro_price_display_exact": "Exact prices",
        "pro_price_display_exact_desc": "Shows the exact amount for each service.",
        "pro_price_display_tiers": "Price tiers",
        "pro_price_display_tiers_desc": "Shows a price range (€ to €€€€).",
        "pro_price_display_hidden": "Hidden",
        "pro_price_display_hidden_desc": "Prices are not displayed publicly.",
        "pro_price_display_saved": "Price display setting updated.",
        "pro_business_info": "Business Information",
        "pro_company_public_name": "My Company (Public name)",
        "pro_company_placeholder": "Ex: Beauty Studio Plus",
        "pro_phone_number": "Phone Number",
        "pro_phone_placeholder": "Ex: 01 23 45 67 89",
        "pro_full_address": "Full Address",
        "pro_address_placeholder": "Ex: 10 Rue de Paris, 75001 Paris",
        "pro_opening_hours": "Opening hours (Free text)",
        "pro_opening_hours_placeholder": "Ex: Monday-Friday 9am-6pm, Saturday 9am-12pm",
        "pro_description_expertise": "Description / Expertise",
        "pro_description_placeholder": "Present your business, your team and your know-how in a few lines...",
        "public_preview": "Public preview",
        "pro_space": "PRO AREA",
        "pro_my_salon": "My Salon",
        "pro_mobile_header": "OpenGlow Pro",
        "pro_greeting": "Hello, {{name}}",
        "pro_overview_subtitle": "Here is an overview of your activity.",
        "pro_revenue": "Completed services",
        "pro_total_earned": "Completed services",
        "pro_completed_services": "Completed services",
        "pro_bookings": "Bookings",
        "pro_reviews_clients": "Client Reviews",
        "pro_based_on_reviews": "Based on your reviews",
        "pro_quick_actions": "Quick Actions",
        "pro_manage_planning": "Manage my schedule",
        "pro_my_services": "My services",
        "pro_need_help": "Need help?",
        "pro_help_text": "Check our guide to improve your page attractiveness and manage better.",
        "pro_view_guide": "View guide",
        "announcement_save_error": "Error while saving",
        "announcement_delete_title": "Delete announcement",
        "announcement_delete_message": "Do you really want to delete this announcement?",
        "announcements_subtitle": "Manage your special offers and news to attract more clients.",
        "announcement_new": "New announcement",
        "announcement_none_title": "No announcements yet",
        "announcement_none_desc": "Create your first announcement to inform your clients about your promotions or news.",
        "announcement_create": "Create announcement",
        "status_active": "Active",
        "status_inactive": "Inactive",
        "deactivate": "Deactivate",
        "activate": "Activate",
        "edit": "Edit",
        "discount_label": "Discount",
        "from_label": "From",
        "to_label": "to",
        "linked_service": "Linked service",
        "announcement_edit": "Edit announcement",
        "announcement_title_label": "Announcement title",
        "announcement_title_placeholder": "Ex: Summer sale -20%",
        "label_description": "Description",
        "announcement_desc_placeholder": "Details of your offer...",
        "announcement_service_optional": "Related service (Optional)",
        "announcement_all_services": "-- All services --",
        "label_type": "Type",
        "type_promotion": "Promotion",
        "type_news": "News",
        "type_event": "Event",
        "type_other": "Other",
        "announcement_discount_optional": "Discount (%) - Optional",
        "announcement_discount_placeholder": "Ex: 20",
        "start_date": "Start date",
        "end_date_optional": "End date (Optional)",
        "captcha_required": "Please complete the CAPTCHA before continuing.",
        "account_not_verified_re_register": "Your account is not verified. Please register again with the same email address to receive a new code.",
        "password_rules_error": "The password does not meet required security rules.",
        "must_be_adult": "You must be at least 15 years old to register.",
        "consent_required": "Please accept the terms and privacy policy.",
        "valid_address_required": "Please select a valid address from the suggested list.",
        "verification_code_invalid": "Invalid or expired code",
        "verify_email_title": "Verify your email",
        "verify_email_message": "We sent a 6-digit code to {{email}}. Enter it below to complete your registration.",
        "validate_account": "Validate my account",
        "edit_my_information": "Edit my information",
        "business_address_label": "Business address",
        "business_address_placeholder": "Enter a full address...",
        "searching": "Searching...",
        "register_consent_prefix": "I have read and accept the",
        "register_consent_terms": "Terms and Conditions",
        "register_consent_and": "and the",
        "register_consent_policy": "Privacy Policy",
        "register_consent_adult": "I confirm that I am at least 15 years old.",
        "admin_access_denied": "Access denied. Admin only.",
        "admin_delete_user_title": "Delete this user",
        "admin_delete_user_message": "Are you sure you want to delete this user? This action is irreversible.",
        "admin_user_deleted": "User deleted successfully.",
        "admin_delete_error": "Error while deleting.",
        "admin_title": "Administration",
        "admin_subtitle": "Monitor and manage platform users.",
        "admin_total_users": "TOTAL USERS",
        "admin_clients": "CLIENTS",
        "admin_professionals": "PROFESSIONALS",
        "admin_users_count": "Users ({{count}})",
        "admin_name_email": "NAME / EMAIL",
        "admin_role": "ROLE",
        "admin_company": "COMPANY",
        "admin_actions": "ACTIONS",
        "delete_booking_title": "Delete booking",
        "confirm_delete_booking_message": "Are you sure you want to delete this booking?",
        "confirm_accept_booking": "Confirm this appointment?",
        "confirm_booking_title": "Confirm appointment",
        "complete_booking_title": "Complete appointment",
        "confirm_complete_booking": "Mark this appointment as completed?",
        "cancel_booking_title": "Cancel appointment",
        "confirm_cancel_booking": "Are you sure you want to cancel this appointment?",
        "cancel_booking_confirm": "Cancel appointment",
        "reviews_login_required": "You must be logged in to leave a review",
        "reviews_delete_confirm": "Delete this review?",
        "reviews_leave": "Leave a review",
        "reviews_already_left": "Review already left",
        "reviews_locked_title": "Review unavailable for now",
        "reviews_eligible_after_completed": "You can leave a review after completing an appointment with this salon.",
        "reviews_stats_title": "Review statistics",
        "reviews_clients_count": "Client reviews ({{count}})",
        "reviews_none_title": "No reviews yet",
        "reviews_none_desc": "Be the first to share your experience",
        "reviews_edit": "Edit your review",
        "reviews_rating_label": "Rating *",
        "rating_5": "Excellent",
        "rating_4": "Very good",
        "rating_3": "Good",
        "rating_2": "Average",
        "rating_1": "Disappointing",
        "reviews_service_optional": "Service (optional)",
        "reviews_no_specific_service": "No specific service",
        "reviews_comment": "Comment",
        "reviews_comment_placeholder": "Share your experience...",
        "reviews_update": "Update",
        "reviews_publish": "Publish",
        "help_topic_profile_title": "Configure my profile",
        "help_topic_profile_desc": "Learn how to showcase your salon with photos, address, and opening info.",
        "help_topic_services_title": "Manage my services",
        "help_topic_services_desc": "Add, edit or disable services available to your clients.",
        "help_topic_planning_title": "My Schedule & Bookings",
        "help_topic_planning_desc": "Understand where to view your upcoming appointments and how to validate them.",
        "help_topic_subscription_title": "Professional subscription",
        "help_topic_subscription_desc": "Get help about upgrading to premium (billing and benefits).",
        "help_faq_1_q": "I forgot my password, how can I reset it?",
        "help_faq_1_a": "For now, please contact support directly with your professional email address for a manual reset.",
        "help_faq_2_q": "Can clients book without my approval?",
        "help_faq_2_a": "By default, clients can book available slots. You will be notified. A manual approval option is coming soon.",
        "help_faq_3_q": "How can I delete a salon photo?",
        "help_faq_3_a": "In the current version, you can upload new photos. To archive older ones, go to the OpenGlow admin console.",
        "help_title": "Hello, how can we help?",
        "help_search_placeholder": "Search a question or topic...",
        "help_faq_title": "Frequently Asked Questions (FAQ)",
        "help_contact_title": "Can't find your answer?",
        "help_contact_desc": "Our professional support team is available by email.",
        "help_contact_cta": "Contact support",
        "map_title": "Professionals Map",
        "map_nearby_count": "{{count}} nearby salon",
        "map_nearby_count_plural": "{{count}} nearby salons",
        "map_you_are_here": "You are here",
        "map_google_maps": "Google Maps",
        "map_waze": "Waze",
        "map_apple_maps": "Apple Maps",
        "action_close": "Close",
        "not_found_title": "404 - Page Not Found",
        "footer_navigation": "Navigation",
        "footer_pro_login": "Pro Login",
        "footer_legal": "Legal",
        "footer_about_us": "About us",
        "footer_privacy": "Privacy",
        "footer_terms_short": "Terms",
        "country_france": "France",
        "quick_guide_title": "User guide",
        "quick_guide_header": "🚀 Quick guide",
        "quick_guide_pro_step_1_title": "Complete your profile",
        "quick_guide_pro_step_1_desc": "Add your information, photo, and salon description",
        "quick_guide_pro_step_2_title": "Add your services",
        "quick_guide_pro_step_2_desc": "Create services with price and duration in the Services tab",
        "quick_guide_pro_step_3_title": "Add photos",
        "quick_guide_pro_step_3_desc": "Showcase your salon with beautiful photos",
        "quick_guide_pro_step_4_title": "Manage your bookings",
        "quick_guide_pro_step_4_desc": "Confirm or cancel your clients' appointments",
        "quick_guide_pro_step_5_title": "View your stats",
        "quick_guide_pro_step_5_desc": "Track your performance in the Bookings page",
        "quick_guide_client_step_1_title": "Search a professional",
        "quick_guide_client_step_1_desc": "Use the Search page to find your salon",
        "quick_guide_client_step_2_title": "View services",
        "quick_guide_client_step_2_desc": "Discover offered services and prices",
        "quick_guide_client_step_3_title": "Book online",
        "quick_guide_client_step_3_desc": "Choose your service, date and time",
        "quick_guide_client_step_4_title": "Manage your appointments",
        "quick_guide_client_step_4_desc": "View and cancel your bookings when needed",
        "cookie_banner_text": "This site uses technical cookies required for operation and",
        "cookie_recaptcha": "Google reCAPTCHA",
        "cookie_banner_recaptcha_suffix": "(data sent to Google for security).",
        "cookie_learn_more": "Learn more",
        "action_decline": "Decline",
        "action_accept": "Accept",
        "email_required": "Email is required.",
        "forgot_password_link": "Forgot password?",
        "forgot_password_title": "Password recovery",
        "forgot_password_intro": "Enter your email to receive a reset code.",
        "send_reset_code": "Send code",
        "back_to_login": "Back to login",
        "reset_password_title": "Reset password",
        "reset_password_intro": "Enter the code received by email and your new password.",
        "reset_code_label": "Reset code",
        "new_password_label": "New password",
        "confirm_new_password_label": "Confirm new password",
        "reset_password_btn": "Reset password",
        "password_reset_request_success": "If an account exists, a reset code has been sent.",
        "password_reset_request_error": "Error sending reset code.",
        "reset_required_fields": "All fields are required.",
        "passwords_mismatch": "Passwords do not match.",
        "password_reset_error": "Error resetting password.",
        "password_reset_success": "Password reset successfully.",
        "change_password_title": "Change password",
        "current_password_label": "Current password",
        "change_password_btn": "Update password",
        "password_change_success": "Password changed successfully.",
        "password_change_error": "Error changing password.",
        "settings_title": "Settings",
        "settings_back": "Back",
        "settings_section_appearance": "Appearance",
        "settings_theme_intro": "Choose the app theme.",
        "settings_theme_classic": "Black & White",
        "settings_theme_ocean": "Ocean",
        "settings_theme_rose": "Rose",
        "settings_theme_dark": "Dark",
        "settings_theme_night": "Night",
        "settings_compact_mode": "Compact mode",
        "settings_compact_mode_sub": "Reduces spacing on this page",
        "settings_section_notifications": "Notifications",
        "settings_notif_email": "Booking emails",
        "settings_notif_email_sub": "Confirmations and appointment reminders",
        "settings_notif_push": "Notification centre",
        "settings_notif_push_sub": "In-app alerts",
        "settings_notif_marketing": "News & offers",
        "settings_notif_marketing_sub": "Product updates and promotions",
        "settings_section_account": "Account",
        "settings_account_profile": "Profile",
        "settings_account_email_label": "Email address",
        "settings_not_connected": "Not connected",
        "settings_section_notifications": "Notifications",
        "settings_booking_sound_label": "Sound for new booking requests",
        "settings_booking_sound_hint": "Plays a sound when a client makes a booking request.",
        "settings_sound_on": "On",
        "settings_sound_off": "Off",
        "settings_sound_enable": "Enable sound",
        "settings_sound_disable": "Disable sound",
        "settings_section_security": "Security",
        "settings_pwd_title": "Change password",
        "settings_pwd_hint": "Choose a strong password (12+ chars, uppercase, number, symbol)",
        "settings_pwd_current": "Current password",
        "settings_pwd_new": "New password",
        "settings_pwd_confirm": "Confirm new password",
        "settings_pwd_submit": "Save password",
        "settings_pwd_submitting": "Saving…",
        "about_title": "About us",
        "about_intro": "OpenGlow is a French platform that makes it easier for clients and beauty professionals to connect.",
        "about_mission_title": "Our mission",
        "about_mission_text": "Help everyone quickly find a trusted professional nearby with a simple, transparent, and modern booking experience.",
        "about_build_title": "What we are building",
        "about_build_item_1": "A clear client area to search, book, and track appointments.",
        "about_build_item_2": "A pro area to manage schedule, services, reviews, and announcements.",
        "about_values_title": "Our values",
        "about_values_simple_label": "Simplicity:",
        "about_values_simple_text": "a fast interface that is easy to understand for everyone.",
        "about_values_trust_label": "Trust:",
        "about_values_trust_text": "clear information and verified profiles.",
        "about_values_respect_label": "Respect:",
        "about_values_respect_text": "protection of personal data and a responsible approach.",
        "about_values_exigence_label": "Excellence:",
        "about_values_exigence_text": "continuous improvement of the user experience.",
        "about_contact_title": "Contact",
        "about_contact_line_1": "Do you have a question or need help?",
        "about_contact_line_2": "Please use the site's internal chat for a faster response.",
        "about_contact_line_3": "For any other request, email us at",
        "settings_show_pwd": "Show",
        "settings_hide_pwd": "Hide"
    }
}